import React, { useState } from 'react';

export const Tooltip =  ({ text }) => {
    const [show, setShow] = useState(false);
   
    const displayTooltip = () => {
        setShow(true);
    }

    const hideTooltip = () => {
        setShow(false);
    }

    return <div className='pl-1'>
         {text && 
            <div class="tooltip-wrapper">
                <div style={{display: show ? 'block' : 'none' }} class="tooltip tooltip-text">{text}</div>
                <i onMouseOver={displayTooltip}  onMouseOut={hideTooltip} class="fas fa-info-circle checkout-header-tooltip tooltip-toggle"></i>
            </div>
        }
    </div>;
}